<template>
  <div :class="name">
    <div :class="`${name}__title`">
      {{ $t('module_product_selected_details_title') }}
    </div>
    <skeleton-basic width="212px" height="20px" style="margin: 4px 0 24px 0;" />
    <skeleton-basic width="100px" height="20px" style="margin-bottom: 4px;" />
    <skeleton-basic width="360px" height="20px" style="margin-bottom: 8px;" />
    <div :class="`${name}__product`">
      <skeleton-basic width="50px" height="50px" style="margin-right: 12px;" />
      <div :class="`${name}__product-detail`">
        <skeleton-basic width="370px" height="22px" style="margin-bottom: 8px;" />
        <skeleton-basic width="185px" height="14px" />
      </div>
    </div>
    <div :class="`${name}__operate`">
      <skeleton-basic width="77px" height="34px" />
      <skeleton-basic width="80px" height="22px" style="margin-left: 4px;" />
    </div>
  </div>
</template>
<script>
import { defineComponent } from '@vue/composition-api';
import SkeletonBasic from '@/components/skeleton/basic.vue';
const name = 'ttam-product-detail-skeleton';
export default defineComponent({
  name,
  components: {
    SkeletonBasic,
  },
  setup() {
    return {
      name,
    };
  },
});
</script>

<style lang="scss">
$name: 'ttam-product-detail-skeleton';
.#{$name} {
  &__title {
    font-size: 18px;
    line-height: 26px;
    font-weight: $font-weight-bold;
    color: $--color-group3-0;
  }
  &__product {
    display: flex;
    align-items: center;
    margin-top: 12px;
    margin-bottom: 16px;
  }
  &__operate {
    display: flex;
    align-items: center;
  }
}
</style>
